import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/baseCargoType/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/baseCargoType',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/baseCargoType',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/baseCargoType/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/baseCargoType',
    method: 'get',
    params: {
      id
    }
  })
}

export function listOption(params) {
  return request({
    url: '/api/base/baseCargoType/listOption',
    method: 'get',
    params
  })
}